// deps
import { useMemo } from "react";

// internal-deps
import { PaymentGroupActions, PaymentMethod, PaymentMethodMeta } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

export const usePaymentActions = ({
    onSelect,
    onPay,
    onLoad,
    onPaymentWalletLoad,
}: Pick<PaymentGroupHandlerProps, "onSelect" | "onPay" | "onPaymentWalletLoad" | "onLoad">): PaymentGroupActions<
    PaymentMethod<PaymentMethodMeta>
> => {
    const paymentActions = useMemo(
        () => ({
            onPay,
            onSelect,
            onPaymentWalletLoad,
            onLoad,
        }),
        [onSelect, onPay, onPaymentWalletLoad, onLoad],
    );

    return paymentActions;
};
